export default {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_IMPERSONATED_BY(state, impersonateByUser) {
    state.impersonatedBy = impersonateByUser;
  },
  SET_LAST_ACCESS(state, lastAccess) {
    state.lastAccess = lastAccess;
  },
  SET_AUTH_MODE(state, authMode) {
    state.authMode = authMode;
  },
  SET_CURRENT_ROLE(state, role) {
    state.currentRole = role;
  },
  SET_TENANT_RIGHTS(state, tenantsRights) {
    state.tenantsRights = tenantsRights;
  },
  SET_ROLES_RIGHTS(state, applicationsRoles) {
    state.applicationsRoles = applicationsRoles;
  },
  SIGNOUT(state) {
    state.token          = null;
    state.impersonatedBy = null;
    state.lastAccess     = null;
    state.currentRole    = null;
    state.tenantsRights  = [];
    state.tenant         = null;
  },
  ADD_WEBCOMPONENT(state, { entryPoint, webComponent }) {
    state.webComponents = {
      ...state.webComponents,
      [entryPoint]: webComponent
    };
  },
  SET_WEBCOMPONENT(state, webComponents) {
    state.webComponents = webComponents;
  },

  // v3
  SET_TOKENS_V3(state, { accessToken, refreshToken, idToken }) {
    state.idToken = idToken;
    state.accessToken  = accessToken;
    state.refreshToken = refreshToken;
    // The v2 compatible token is the refresh token
    state.token        = refreshToken;
  }
};
